import TrackingLinesList from '../../../../components/Main/Tracking/Lines/TrackingLinesList'
import TrackingLinesModal from '../../../../components/Main/Tracking/Lines/TrackingLinesModal'
import React, { Fragment } from 'react'

function TrackingLines(props) {
  return (
    <Fragment>
      <TrackingLinesModal {...props} />
      <TrackingLinesList {...props} />
    </Fragment>
  )
}

export default TrackingLines
